import React, { FC } from "react";

type MandatoryDocsAlertProps = {
  pendingSteps?: string;
}

const MandatoryDocsAlert: FC<MandatoryDocsAlertProps> = ({
  pendingSteps
}) => (
  <div
    className="w-100 min-w-280px radius-8px bg-teal-pale p-15px text-black fs-13 fw-400"
    style={{
      position: "absolute",
      bottom: "-75px",
      left: "50%",
      right: 0,
      margin: "0 auto",
      zIndex: 10,
      boxShadow: "-4px 4px 20px 0 rgba(0,0,0,0.15)",
      lineHeight: "1.4",
      transform: "translateX(-50%)"
    }}
  >
    Please complete {pendingSteps && pendingSteps.split(',').length > 1 ? 'these' : 'the'} mandatory {pendingSteps && pendingSteps.split(',').length > 1 ? 'steps' : 'step'} first: {pendingSteps}
    <div
      className="arrow"
      style={{
        position: "absolute",
        top: "-15px",
        left: "50%",
        transform: "translateX(-50%)",
        width: 0,
        height: 0,
        borderLeft: "15px solid transparent",
        borderRight: "15px solid transparent",
        borderBottom: "15px solid #f6ffff",
      }}
    />
  </div>
);

export default MandatoryDocsAlert;
